//Global Vars
var count;
getdata = {
    webflow: () => {
        console.log('webflow')
    },
    firebase: (Col, callback) => {
        db.collection(`/collections/${Col}/items`)
            .orderBy("name", "asc").onSnapshot(querySnapshot => {
                var resArray = []
                querySnapshot.forEach(doc => {
                    var data = doc.data();
                    data._id = doc.id;
                    resArray.push(data)
                });
                callback(resArray);
            });
    },
    singleItem: async (Col, id, callback) => {
        var doc = await db.doc(`collections/${Col}/items/${id}`).get();
        callback(doc.data());
    }
}
deleteItem = {
    firebase: (Col, id, callback) => {
        db.doc(`collections/${Col}/items/${id}`)
            .delete()
            .then(() => {
                callback({ err: false })
            })
            .catch(error => {
                callback({ err: true, problems: ["Error removing document: " + error] })
            });
    },
    webflow: (Col, id, callback) => {
        // var link =
        //     "https://cors-anywhere.herokuapp.com/https://api.webflow.com/collections/" +
        //     Col +
        //     "/items/" +
        //     id +
        //     "?access_token=" +
        //     wfToken +
        //     "&api_version=1.0.0";
        let action = "remove"
        let data = {
            "site": siteID,
            "collectionId": Col,
            "itemId": id,
        }
        var settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://us-central1-bageladmin.cloudfunctions.net/webflow/" + action,
            "method": "POST",
            "headers": {
                "Accept": "*/*",
                "Cache-Control": "no-cache",
                "cache-control": "no-cache"
            },
            "data": data
        }

        $.ajax(settings).done((res) => callback(res));
    }
}

publish = {
    webflow: (info, Col, id, callback) => {
        let action;
        if (id == 'new-item') {
            info._archived = false;
            action = "create"
            id = null;
        } else if (!info && id){
            action = "remove"
        } else  {
            action = "update"
        }

        // var link =
        //     "https://cors-anywhere.herokuapp.com/https://api.webflow.com/collections/" +
        //     Col +
        //     "/items/" +
        //     id +
        //     "?live=true&access_token=" +
        //     wfToken +
        //     "&api_version=1.0.0";
        if (info){
            delete info["updated-on"];
            delete info["updated-by"];
            delete info["created-on"];
            delete info["created-by"];
            delete info["published-on"];
            delete info["published-by"];
            delete info["_cid"];
            delete info["_id"];
            delete info["hide-from-rss"];

            if (!info._archived) { info._archived = false }
            if (!info._draft) { info._draft = false }
            $.each(info, (key, item) => {

                if (typeof item === "string") {
                    info[key] = item.trim().replace(/^<p><br><\/p>/, "");
                }
            });
            var itemSlug;
            if (!info.slug) {
                itemSlug = info.name;
            } else {
                itemSlug = info.slug;
            }
            itemSlug = itemSlug
                .replace(/[,\)\("'<>#%{}|()\\\/^~[\]`;?:@=&]/g, "")
                .replace(/\s/g, "-");
            info.slug = transliterate(itemSlug).toLowerCase();
            if (info.hiddenslug) {
                info.hiddenslug += info.slug;
            }
        }

        let data = {
            "site": siteID,
            "collectionId": Col,
            "itemId": id,
            "fields": JSON.stringify(info)
        }
        var settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://us-central1-bageladmin.cloudfunctions.net/webflow/" + action,
            "method": "POST",
            "headers": {
                "Accept": "*/*",
                "Cache-Control": "no-cache",
                "cache-control": "no-cache"
            },
            "data": data
        }

        $.ajax(settings).done((inf) => {
            console.log(inf)
            if (inf.name == "UnknownError") {
                var link =
                    "https://cors.bagelstudio.co/api.webflow.com/collections/" +
                    Col + '/items/' + id +
                    "/?access_token=" +
                    wfToken +
                    "&api_version=1.0.0";

                $.get(link, (result) => {
                    $.each(result, (i, e) => {
                        if (e == undefined) {
                            delete result[i]
                        }
                    })
                    var res = result.items[0];
                    db.doc(`collections/${res._cid}/items/${res._id}`)
                        .set(res)
                        .then(() => {
                            callback(res)
                        });
                })
                return;
            }
            window.info = inf;
            if (inf.err) {
                callback(inf)
                return
            }
            $.each(info, (i, e) => {
                if (e == undefined) {
                    delete info[i]
                }
            })
            db.doc(`collections/${inf._cid}/items/${inf._id}`)
                .set(info)
                .then(() => {
                    info._id = inf._id
                    callback(info)
                });

            // callback(response)
        });

        // var x = new XMLHttpRequest();
        // x.open(method, link);
        // x.onerror = () => {
        //     alert("error", x.responseText);
        // };

        // x.setRequestHeader("Content-Type", "application/json");
        // x.send('{"fields": ' + JSON.stringify(info) + "}");
    },
    firebase(info, Col, id, callback) {
        if (id == 'new-item') {
            db.collection(`collections/${Col}/items`)
                .add(info)
                .then(doc => {
                    info._id = doc.id;
                    callback(info)
                });
        } else {
            info._id = id
            db.doc(`collections/${Col}/items/${id}`)
                .set(info)
                .then(() => {
                    callback(info)
                });
        }

    }
}

transliterate = (string) => {
    var tr = {
        א: "a",
        ב: "b",
        ג: "g",
        ד: "d",
        ה: "h",
        ו: "u",
        ז: "z",
        ח: "h",
        ט: "t",
        י: "i",
        כ: "k",
        ך: "ch",
        ל: "l",
        מ: "m",
        ם: "m",
        נ: "n",
        ן: "n",
        ס: "s",
        ע: "a",
        פ: "p",
        ף: "f",
        צ: "z",
        ק: "k",
        ר: "r",
        ש: "sh",
        ת: "t"
    };
    var result = "";
    for (let i = 0; i < string.length; i++) {
        if (tr[string[i]]) {
            result += tr[string[i]];
        } else result += string[i];
    }
    return result;
};


downloadCSV = async (colId, limitArr) => {

    var headers = [];
    var images = [];
    var multivars = [];
    var rtf = [];
    var multivarsData = {};
    var slugs = [];
    var schamaSnapshot = await db.doc('collections/' + colId).get();
    var schema = schamaSnapshot.data().fields;
    var title = schamaSnapshot.data().name;
    var data = [];
    if (!limitArr) {
        var dataSnapshot = await db.collection('collections/' + colId + '/items').get();
        dataSnapshot.forEach(doc => {
            var item = doc.data();
            item._id = doc.id;
            data.push(item);
        });
    } else {
        data = await Promise.all(limitArr.map(async id => {
            var docSnapshot = await db.doc('collections/' + colId + '/items/' + id).get();
            if (!docSnapshot.exists) return { name: 'Deleted' };
            var item = docSnapshot.data();
            item._id = docSnapshot.id;
            return item;
        }));
    }

    $.each(schema, (i, e) => {
        if (
            e.type == "PlainText" ||
            e.type == "RichText" ||
            e.type == "Number" ||
            e.type == "Link" ||
            e.type == "ItemRefSet" ||
            e.type == "ItemRef" ||
            e.type == "ImageRefSet" ||
            e.type == "ImageRef"
        ) {
            headers.push(e.name);
            slugs.push(e.slug);
        }

        if (e.type == "RichText") rtf.push(e.slug);

        if (e.type == "ImageRef" || e.type == "ImageRefSet") {
            images.push({
                slug: e.slug,
                type: e.type
            });
        }

        if (e.type == "ItemRef" || e.type == "ItemRefSet") {
            multivars.push({
                slug: e.slug,
                type: e.type,
                collection: e.validations.collectionId
            });
        }
    });

    var finalData = await Promise.all(data.map(async o => {
        var d = {}
        slugs.forEach(s => {
            if (o[s]) {
                switch (typeof o[s]) {
                    case String:
                        d[s] = o[s].trim() ? o[s].trim() : '-';
                        break;
                    default:
                        d[s] = o[s];
                }
            } else {
                d[s] = '-'
            }

        })
        if (rtf) {
            rtf.forEach(e => {
                var div = document.createElement("div");
                $(div).html(d[e]);
                var text = div.textContent || div.innerText || ""
                d[e] = text.replace(/"/gi, "״");
            })
        }
        if (images) {
            images.map(e => {
                if (e.type == "ItemRefSet" && d[e.slug]) {
                    d[e.slug] = JSON.stringify(data[e.slug]);
                } else if (data[e.slug]) {
                    d[e.slug] = data[e.slug]["url"];
                }
            });
        }
        if (multivars) {
            await Promise.all(multivars.map(async e => {
                if (d[e.slug] != '-') {
                    if (!multivarsData[e.collection]) multivarsData[e.collection] = [];
                    if (e.type == 'ItemRef') {
                        var cached = multivarsData[e.collection].find(m => m._id == d[e.slug]);
                        if (cached) {
                            d[e.slug] = cached.name.replace(/"/gi, "");
                        } else {
                            let snapshot = await db.doc(`collections/${e.collection}/items/${d[e.slug]}`).get();
                            if (snapshot.exists) {
                                var itemData = snapshot.data();
                                itemData._id = snapshot.id
                                d[e.slug] = itemData.name.replace(/"/gi, "");
                                multivarsData[e.collection].push(itemData);
                            } else {
                                d[e.slug] = '-';
                            }
                            return;
                        }
                    } else if (typeof d[e.slug] == "object") {
                        var itemArray = await Promise.all(d[e.slug].map(async it => {
                            var cached = multivarsData[e.collection].find(m => m._id == it);
                            if (cached) {
                                return cached.name.replace(/"/gi, "");
                            } else {
                                let snapshot = await db.doc(`collections/${e.collection}/items/${it}`).get();
                                if (!snapshot.exists) return;
                                var itemData = snapshot.data();
                                itemData._id = snapshot.id;

                                multivarsData[e.collection].push(itemData);
                                return snapshot.data().name.replace(/"/gi, "");
                            }
                        }));
                        d[e.slug] = itemArray.toString();

                        return d;
                    }
                }
            }))
            return d;
        } else {
            return d;
        }
    }));
    exportCSVFile(headers, finalData, title);
}

function exportCSVFile(headers, data, fileTitle) {
    var csv = '';
    if (headers) {
        csv += JSON.stringify(headers).replace(/[\[\]]/gi, "") + '\r\n'
    }
    for (i of data) {
        var str = ''
        for (var [key, value] of Object.entries(i)) {
            str += `"${value}",`
        }
        csv += str + '\r\n';
    }

    var exportedFilenmae = fileTitle + ".csv" || "export.csv";
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

function convertToCSV(objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";
    for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
            if (line != "") line += ",";
            line += array[i][index];
        }
        str += line + "\r\n";
    }
    return str;
};
